<template>
  <div class="time-sheet">
    <div
      class="time-sheet-statical"
      :class="
        !isSubmitable || timesheetDashboard.checkSubmitted
          ? 'submit--success'
          : ''
      "
    >
      <div
        v-if="!isSubmitable || timesheetDashboard.checkSubmitted"
        class="submit-tick--success"
      >
        {{ $t("dashboard.title.submited") }}
      </div>
      <div class="statical-header">
        <div class="header-title">
          {{ $t("dashboard.title.timesheet_statical") }}
        </div>
        <!-- <div class="header-time-remain submited-time" v-if="isSubmited">
          <img src="/img/icons/checked-icon.svg" alt="time remain" /> Đã submit
          công
        </div> -->
        <div class="filter-wrapper">
          <div class="filter-datepicker">
            <a-month-picker
              class="datepicker__input"
              placeholder="Tháng"
              :format="`[Tháng] M/YYYY`"
              :value="searchData.month"
              @change="search"
              :disabled-date="disableMonth"
              :allowClear="false"
              valueFormat="M/YYYY"
            >
              <img slot="suffixIcon" src="/img/icons/calendar-icon.svg" />
            </a-month-picker>
          </div>
        </div>
      </div>
      <div class="statical-content">
        <a-row :gutter="[12, 12]">
          <a-col :md="12">
            <div class="statical-item">
              <div class="item-header text-center">
                {{ $t("dashboard.title.total_timesheet") }}
                <div class="text_color--blue fs-70 fw-700">
                  {{ timesheetDashboard.dayWorking || 0 }}
                </div>
                <div class="text_color--grey">
                  {{ $t("dashboard.title.date") }}
                </div>
              </div>
              <div class="item-footer text-center">
                <div class="mt-4">{{ $t("dashboard.title.time_work") }}</div>
                <div class="text_color--green time-item">{{ this.account.work_shift.morning_shift_start.slice(0, 5) }}-{{ this.account.work_shift.afternoon_shift_end.slice(0, 5) }}</div>
              </div>
            </div>
          </a-col>
          <a-col :md="12">
            <div class="statical-item">
              <div class="item-header text-center">
                {{ $t("dashboard.title.total_real_timesheet") }}
                <div class="text_color--red fs-70 fw-700">
                  {{ formatNumber(timesheetDashboard.dayWorkingReal || 0) }}
                </div>
                <div class="text_color--grey">
                  {{ $t("dashboard.title.date") }}
                </div>
              </div>
              <div class="item-footer text-center">
                <div>
                  {{ $t("dashboard.title.miss_timesheet") }}
                  <span class="text_color--red">
                    {{
                      formatNumber(timesheetDashboard.missTimesheet * 8 || 0)
                    }}
                    {{ $t("dashboard.title.hour") }}
                    ({{ timesheetDashboard.missTimesheet }}
                    {{ $t("dashboard.title.date") }})
                  </span>
                </div>
                <button
                  class="footer-btn submit-btn mt-3 submited-disable"
                  :class="
                    timesheetDashboard.missTimesheet === 0 && 'btn-disabled'
                  "
                  :disabled="
                    timesheetDashboard.checkSubmitted ||
                    timesheetDashboard.missTimesheet === 0 ||
                    !isSubmitable
                  "
                  @click="onclickOpenAddTimesheet"
                >
                  {{ $t("dashboard.button.add_timesheet") }}
                </button>
              </div>
            </div>
          </a-col>
          <a-col :md="24">
            <div class="statical-item">
              <div class="item-header header-title">
                {{ $t("dashboard.title.detail_real_timesheet") }}
              </div>
              <div class="item-footer">
                <a-row class="real-timesheet-list">
                  <div class="real-timesheet-item">
                    {{ $t("dashboard.label.real_timesheet") }}
                    <span class="text_color--green">
                      {{
                        formatNumber(timesheetDashboard.normalDayWorking || 0)
                      }}
                      {{ $t("dashboard.title.date") }}</span
                    >
                  </div>
                  <div class="real-timesheet-item item-mobile">
                    {{ $t("dashboard.label.ot_timesheet") }}
                    <span class="text_color--green">
                      {{
                        formatNumber(
                          timesheetDashboard.overtimeRequestTotal || 0
                        )
                      }}
                      {{ $t("dashboard.title.date") }}</span
                    >
                  </div>
                  <div class="real-timesheet-item">
                    {{ $t("dashboard.label.sabbatical_leave") }}
                    <span class="text_color--green">
                      {{
                        formatNumber(timesheetDashboard.sabbaticalLeave || 0)
                      }}
                      {{ $t("dashboard.title.date") }}</span
                    >
                  </div>
                  <div class="real-timesheet-item">
                    {{ $t("dashboard.label.leave") }}
                    <span class="text_color--green">
                      {{ formatNumber(timesheetDashboard.unpaidLeave || 0) }}
                      {{ $t("dashboard.title.date") }}</span
                    >
                  </div>
                  <div class="real-timesheet-item" :md="6" :span="12">
                    {{ $t("dashboard.label.added_timesheet") }}
                    <span class="text_color--green">
                      {{
                        formatNumber(
                          timesheetDashboard.totalCompensation * 8 || 0
                        )
                      }}
                      {{ $t("dashboard.title.hour") }}
                      ({{
                        formatNumber(timesheetDashboard.totalCompensation || 0)
                      }}
                      {{ $t("dashboard.title.date") }})
                    </span>
                  </div>
                  <!-- Physiology -->
                  <!-- <div class="real-timesheet-item" :md="6" :span="12">
                    {{ $t("dashboard.label.physiology_timesheet") }}
                    <span class="text_color--green">
                      (
                        {{timesheetDashboard.physiologicalLeaveTotal}}
                      {{ $t("dashboard.title.minute") }})
                    </span>
                  </div> -->
                </a-row>
              </div>
            </div>
          </a-col>
          <a-col :md="6">
            <div class="statical-item">
              <div class="item-header">
                <router-link
                  :to="{
                    name: 'Overtime Request',
                    query: {
                      month: moment(searchData.month, 'M/YYYY').format(
                        'MM/YYYY'
                      ),
                      currentPage: 1,
                      perPage: 10,
                      sortColumn: 'work_date',
                      sortBy: 'DESC',
                    },
                  }"
                  class="header-title"
                >
                  {{ $t("dashboard.label.ot_request_status") }}
                </router-link>
              </div>
              <div class="item-footer">
                <div class="list-item">
                  <div class="item-label">
                    {{ $t("dashboard.label.total_accepted_request") }}
                  </div>
                  <span class="text_color--green"
                    >{{ timesheetTotalRequest.totalOTRequestStatus[2] }}
                    {{ $t("dashboard.title.request") }}</span
                  >
                </div>
                <div class="list-item">
                  <div class="item-label">
                    {{ $t("dashboard.label.total_reject_request") }}
                  </div>
                  <span class="text_color--green"
                    >{{ timesheetTotalRequest.totalOTRequestStatus[3] }}
                    {{ $t("dashboard.title.request") }}</span
                  >
                </div>
                <div class="list-item">
                  <div class="item-label">
                    {{ $t("dashboard.label.total_pending_request") }}
                  </div>
                  <span class="text_color--green"
                    >{{ timesheetTotalRequest.totalOTRequestStatus[1] }}
                    {{ $t("dashboard.title.request") }}</span
                  >
                </div>
              </div>
            </div>
          </a-col>
          <a-col :md="6">
            <div class="statical-item">
              <div class="item-header header-title">
                <router-link
                  :to="{
                    name: 'Additional Timesheet',
                    query: {
                      month: moment(searchData.month, 'M/YYYY').format(
                        'MM/YYYY'
                      ),
                      currentPage: 1,
                      perPage: 10,
                      sortColumn: 'work_date',
                      sortBy: 'DESC',
                    },
                  }"
                  class="header-title"
                >
                  {{ $t("dashboard.label.timesheet_request_status") }}
                </router-link>
              </div>
              <div class="item-footer">
                <div class="list-item">
                  <div class="item-label">
                    {{ $t("dashboard.label.total_accepted_request") }}
                  </div>
                  <span class="text_color--green"
                    >{{ timesheetTotalRequest.totalTimesheetRequestStatus[2] }}
                    {{ $t("dashboard.title.request") }}</span
                  >
                </div>
                <div class="list-item">
                  <div class="item-label">
                    {{ $t("dashboard.label.total_reject_request") }}
                  </div>
                  <span class="text_color--green"
                    >{{ timesheetTotalRequest.totalTimesheetRequestStatus[3] }}
                    {{ $t("dashboard.title.request") }}</span
                  >
                </div>
                <div class="list-item">
                  <div class="item-label">
                    {{ $t("dashboard.label.total_pending_request") }}
                  </div>
                  <span class="text_color--green"
                    >{{ timesheetTotalRequest.totalTimesheetRequestStatus[1] }}
                    {{ $t("dashboard.title.request") }}</span
                  >
                </div>
              </div>
            </div>
          </a-col>
          <a-col :md="6">
            <div class="statical-item">
              <div class="item-header">
                <router-link
                  :to="{
                    name: 'Sabbatical leave request',
                    query: {
                      startDate: moment(searchData.month, 'MM/YYYY')
                        .startOf('month')
                        .format('DD-MM-YYYY'),
                      endDate: moment(searchData.month, 'MM/YYYY')
                        .endOf('month')
                        .format('DD-MM-YYYY'),
                      currentPage: 1,
                      perPage: 10,
                      sortColumn: 'updated_at',
                      sortBy: 'DESC',
                    },
                  }"
                  class="header-title"
                >
                  {{ $t("dashboard.label.sabbatical_leave_request_status") }}
                </router-link>
              </div>
              <div class="item-footer">
                <div class="list-item">
                  <div class="item-label">
                    {{ $t("dashboard.label.total_accepted_request") }}
                  </div>
                  <span class="text_color--green"
                    >{{
                      timesheetTotalRequest.totalSabbaticalRequestStatus[2]
                    }}
                    {{ $t("dashboard.title.request") }}</span
                  >
                </div>
                <div class="list-item">
                  <div class="item-label">
                    {{ $t("dashboard.label.total_reject_request") }}
                  </div>
                  <span class="text_color--green"
                    >{{
                      timesheetTotalRequest.totalSabbaticalRequestStatus[3]
                    }}
                    {{ $t("dashboard.title.request") }}</span
                  >
                </div>
                <div class="list-item">
                  <div class="item-label">
                    {{ $t("dashboard.label.total_pending_request") }}
                  </div>
                  <span class="text_color--green"
                    >{{
                      timesheetTotalRequest.totalSabbaticalRequestStatus[1]
                    }}
                    {{ $t("dashboard.title.request") }}</span
                  >
                </div>
              </div>
            </div>
          </a-col>
           <a-col :md="6">
            <div class="statical-item">
              <div class="item-header">
                <router-link
                  :to="{
                    name: 'RemoteRequest',
                    query: {
                      startDate: moment(searchData.month, 'MM/YYYY')
                        .startOf('month')
                        .format('DD-MM-YYYY'),
                      endDate: moment(searchData.month, 'MM/YYYY')
                        .endOf('month')
                        .format('DD-MM-YYYY'),
                      currentPage: 1,
                      perPage: 10,
                      sortColumn: 'updated_at',
                      sortBy: 'DESC',
                    },
                  }"
                  class="header-title"
                >
                  {{ $t("dashboard.label.remote_request_status") }}
                </router-link>
              </div>
              <div class="item-footer">
                <div class="list-item">
                  <div class="item-label">
                    {{ $t("dashboard.label.total_accepted_request") }}
                  </div>
                  <span class="text_color--green"
                    >{{
                      timesheetTotalRequest.totalRemoteRequestStatus[2]
                    }}
                    {{ $t("dashboard.title.request") }}</span
                  >
                </div>
                <div class="list-item">
                  <div class="item-label">
                    {{ $t("dashboard.label.total_reject_request") }}
                  </div>
                  <span class="text_color--green"
                    >{{
                      timesheetTotalRequest.totalRemoteRequestStatus[3]
                    }}
                    {{ $t("dashboard.title.request") }}</span
                  >
                </div>
                <div class="list-item">
                  <div class="item-label">
                    {{ $t("dashboard.label.total_pending_request") }}
                  </div>
                  <span class="text_color--green"
                    >{{
                      timesheetTotalRequest.totalRemoteRequestStatus[1]
                    }}
                    {{ $t("dashboard.title.request") }}</span
                  >
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <div class="statical-footer">
        <div
          class="footer-button"
          v-if="!timesheetDashboard.checkSubmitted && isSubmitable"
        >
          <button class="footer-btn submit-btn" @click="onClickOpenSubmit">
            <!-- <img src="/img/icons/check-circle-icon.svg" alt="" />Submit công -->
            {{ $t("dashboard.button.submit_timesheet") }}
          </button>
          <TimesheetSubmitModal
            :open="isOpenSubmit"
            :dayOfWorking="timesheetDashboard.dayWorking"
            :dayOfWorkingReal="timesheetDashboard.dayWorkingReal"
            :normalDayWorking="timesheetDashboard.normalDayWorking"
            :overtimeRequestTotal="timesheetDashboard.overtimeRequestTotal"
            :sabbaticalLeave="timesheetDashboard.sabbaticalLeave"
            :unpaidLeave="timesheetDashboard.unpaidLeave"
            :totalCompensation="timesheetDashboard.totalCompensation"
            @submitable="submitable"
            @close="isOpenSubmit = !isOpenSubmit"
          />
          <!-- <button class="footer-btn compenstate-btn" @click="isOpenAdd = true">
            <img src="/img/icons/frame-icon.svg" alt="" />Bù công thiếu
          </button> -->
          <AddTimesheetModal
            @confirm="handleAddTimesheet"
            :open="isOpenAdd"
            @close="closeAddTimesheetModal"
            :missTimesheet="timesheetDashboard.missTimesheet"
            :numberOfDaysLeave="timesheetDashboard.numberOfDaysLeave"
            :numberOfDaysLeaveAvailable="
              dataCommons.all_time_days_off_sabbatical_rest_real
            "
          />
        </div>
        <div
          class="footer-button"
          v-if="
            timesheetDashboard.checkSubmitted &&
            isSubmitable &&
            sumittedInfomation.submit_period.submitable
          "
        >
          <button class="footer-btn unsubmit-btn" @click="onClickUnsubmit">
            <!-- <img src="/img/icons/close-icon.svg" alt="" />Hủy submit công -->
            {{ $t("dashboard.button.unsubmit_timesheet") }}
          </button>
        </div>
        <TimesheetSubmitConfimModal
          :open="isOpenConfirm"
          @close="closeUnsubmitModal"
          @unsubmitable="unsubmitable"
        />
      </div>
    </div>
    <div class="table-list">
      <CCard>
        <CCardBody>
          <div class="card__header">
            <div class="card-header__content">
              {{ $t("dashboard.label.timesheet_list") }}
            </div>

            <div class="" v-if="account.is_remote_working === true">
              <CButton
                color="info mr-1"
                @click.prevent="employeeCheckIn()"
                :disabled="
                  timeSheetToday.start_time_real !== null &&
                  timeSheetToday.start_time_real !== ''
                "
                >Check In</CButton
              >
              <CButton
                color="warning ml-1"
                @click.prevent="employeeCheckOut()"
                :disabled="
                  timeSheetToday.start_time_real === null ||
                  timeSheetToday.start_time_real === ''
                "
                >Check out</CButton
              >
            </div>
          </div>
          <div class="table-wrapper">
            <table class="table-content">
              <thead class="table-header">
                <tr>
                  <th class="cl-pointer" rowspan="2">
                    {{ $t("timeSheets.date") }}
                  </th>
                  <th colspan="2">
                    {{ $t("dashboard.table.time_checkin_checkout") }}
                  </th>
                  <th colspan="2">{{ $t("dashboard.table.time_pay") }}</th>
                  <th colspan="3">
                    {{ $t("dashboard.table.real_timesheet") }}
                  </th>
                  <th rowspan="2">{{ $t("dashboard.table.status") }}</th>
                  <th rowspan="2">{{ $t("dashboard.table.action") }}</th>
                </tr>
                <tr>
                  <th>{{ $t("dashboard.table.start_time_real") }}</th>
                  <th>{{ $t("dashboard.table.end_time_real") }}</th>
                  <th>{{ $t("dashboard.table.time_start") }}</th>
                  <th>{{ $t("dashboard.table.time_end") }}</th>
                  <th>{{ $t("dashboard.table.nomal_timesheet") }}</th>
                  <th>{{ $t("dashboard.table.ot_timesheet") }}</th>
                  <th>{{ $t("dashboard.table.total") }}</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <template v-if="timeSheets && timeSheets.length > 0">
                  <tr
                    v-for="(timeSheet, index) in timeSheets"
                    :key="index"
                    :class="classDayOff(timeSheet.day_off)"
                  >
                    <td>
                      <div class="work_date">
                        <div>
                          {{ timeSheet.work_date }}
                        </div>
                        <div>
                          {{ $t(`timeSheets.${timeSheet.day_of_week}`) }}
                        </div>
                      </div>
                    </td>
                    <td>
                      <span
                        v-if="timeSheet.start_time_real"
                        class="employee__badge"
                      >
                        <img
                          :class="
                            timeSheet.start_time_real > timeSheet.start_time_pay
                              ? 'img__higher'
                              : 'img__lower'
                          "
                          src="../../assets/icons/clock.svg"
                          alt=""
                        />
                        <span
                          :class="
                            timeSheet.start_time_real > timeSheet.start_time_pay
                              ? 'span__higher'
                              : 'span__lower'
                          "
                        >
                          {{ timeSheet.start_time_real }}
                        </span>
                      </span>
                      <div v-else>-</div>
                    </td>
                    <td>
                      <span
                        v-if="timeSheet.end_time_real"
                        class="employee__badge"
                      >
                        <img
                          :class="
                            timeSheet.end_time_real < timeSheet.end_time_pay
                              ? 'img__higher'
                              : 'img__lower'
                          "
                          src="../../assets/icons/clock.svg"
                          alt=""
                        />
                        <span
                          :class="
                            timeSheet.end_time_real < timeSheet.end_time_pay
                              ? 'span__higher'
                              : 'span__lower'
                          "
                        >
                          {{ timeSheet.end_time_real }}
                        </span>
                      </span>
                      <div v-else>-</div>
                    </td>
                    <!-- <td>
                      {{
                        timeSheet.start_time_pay
                          ? timeSheet.start_time_pay
                          : "-"
                      }}
                    </td> -->
                    <!-- <td>
                      {{
                        timeSheet.end_time_pay ? timeSheet.end_time_pay : "-"
                      }}
                    </td> -->
                    <td>
                      {{
                        timeSheet.day_off === 0 && timeSheet.normal_time_pay
                          ? timeSheet.start_time_pay
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        timeSheet.day_off === 0 && timeSheet.normal_time_pay
                          ? timeSheet.end_time_pay
                          : "-"
                      }}
                    </td>
                    <td>
                      <span
                        v-if="
                          timeSheet.normal_time_pay ||
                          (timeSheet.day_off == 2 &&
                            checkIsWeekend(timeSheet.day_of_week) == false)
                        "
                        :class="
                          timeSheet.normal_time_pay < '08:00'
                            ? 'span__higher'
                            : ''
                        "
                      >
                        {{ timeSheet.normal_time_pay }}
                      </span>
                      <span v-else> - </span>
                    </td>
                    <td>
                      <span
                        v-if="timeSheet.ot_150 && timeSheet.ot_150 !== '00:00'"
                      >
                        {{ `${timeSheet.ot_150} x 150%` }}
                      </span>
                      <span
                        v-else-if="
                          timeSheet.ot_200 && timeSheet.ot_200 !== '00:00'
                        "
                      >
                        {{ `${timeSheet.ot_200} x 200%` }}
                      </span>
                      <span v-else> - </span>
                    </td>
                    <td>
                      {{
                        (timeSheet.ot_time_minus_late_early !== "" &&
                          timeSheet.ot_time_minus_late_early !== "00:00") ||
                        (timeSheet.work_time_pay !== "00:00" &&
                          timeSheet.work_time_pay !== "")
                          ? sumWorkTime(
                              timeSheet.work_time_pay,
                              timeSheet.ot_time_minus_late_early,
                              timeSheet.sabbatical_leave_type,
                              timeSheet.sabbatical_leave_minute,
                              timeSheet.day_off == 2 || timeSheet.day_off == 3,
                          )
                          : '-'
                      }}
                    </td>

                    <td>
                      <span
                        class="employee__dayoff"
                        v-if="timeSheet.day_off === 1"
                      >
                        Cuối tuần
                      </span>
                      <span
                        class="employee__holiday-off"
                        v-else-if="timeSheet.day_off === 2"
                      >
                        Ngày lễ
                      </span>
                      <span
                        class="employee__holiday-off"
                        v-else-if="timeSheet.day_off === 3"
                      >
                        Nghỉ bù lễ
                      </span>
                      <span
                        class="employee__dayoff"
                        v-else-if="timeSheet.paid_leave > 0"
                      >
                        Nghỉ phép
                      </span>
                      <span
                        class="employee__leave"
                        v-else-if="
                          (!timeSheet.work_time_pay ||
                            timeSheet.work_time_pay == '00:00') &&
                          timeSheet.day_off === 0
                        "
                      >
                        Nghỉ không lương
                      </span>
                      <span class="employee__work" v-else> Đi làm </span>
                      <br>
                      <span class="employee__physiological"
                        v-if="timeSheet.sabbatical_leave_minute"
                      > Nghỉ sinh lý:  {{timeSheet.sabbatical_leave_minute}} phút</span>
                    </td>
                    <td class="justify-content-center">
                      <div
                        class="action-btn-group"
                        v-if="
                          !timesheetDashboard.checkSubmitted && isSubmitable
                        "
                      >
                        <a-tooltip>
                          <template slot="title">
                            <div
                              v-if="
                                timeSheet.total_timesheet_request ||
                                timeSheet.total_timesheet_request_confirm ||
                                timeSheet.total_timesheet_request_reject
                              "
                            >
                              {{
                                $t("dashboard.title.tooltip1") +
                                (timeSheet.total_timesheet_request ||
                                  timeSheet.total_timesheet_request_confirm ||
                                  timeSheet.total_timesheet_request_reject) +
                                $t("dashboard.title.timesheet_tooltip2") +
                                getTitleRequestStatus(
                                  timeSheet.total_timesheet_request,
                                  timeSheet.total_timesheet_request_confirm,
                                  timeSheet.total_timesheet_request_reject
                                )
                              }}
                              <div>
                                {{ $t("dashboard.title.timesheet_tooltip3") }}
                              </div>
                            </div>
                            <div v-else>
                              {{ $t("dashboard.modal.edit_timesheet") }}
                            </div>
                          </template>
                          <div
                            class="btn-fix__timeSheet"
                            @click="
                              $refs.createTimesheet.showModal(
                                timeSheet.work_date
                              )
                            "
                          >
                            <img
                              src="../../assets/icons/pencil-icon.svg"
                              alt=""
                            />
                            <div
                              v-if="
                                timeSheet.total_timesheet_request ||
                                timeSheet.total_timesheet_request_confirm ||
                                timeSheet.total_timesheet_request_reject
                              "
                              class="badge"
                              :class="
                                classRequestStatus(
                                  timeSheet.total_timesheet_request,
                                  timeSheet.total_timesheet_request_confirm,
                                  timeSheet.total_timesheet_request_reject
                                )
                              "
                            >
                              {{
                                timeSheet.total_timesheet_request ||
                                timeSheet.total_timesheet_request_confirm ||
                                timeSheet.total_timesheet_request_reject
                              }}
                            </div>
                          </div>
                        </a-tooltip>
                        <a-tooltip>
                          <template slot="title">
                            <div
                              v-if="
                                timeSheet.total_ot_request ||
                                timeSheet.total_ot_request_confirm ||
                                timeSheet.total_ot_request_reject
                              "
                            >
                              {{
                                $t("dashboard.title.tooltip1") +
                                (timeSheet.total_ot_request ||
                                  timeSheet.total_ot_request_confirm ||
                                  timeSheet.total_ot_request_reject) +
                                $t("dashboard.title.ot_tooltip2") +
                                getTitleRequestStatus(
                                  timeSheet.total_ot_request,
                                  timeSheet.total_ot_request_confirm,
                                  timeSheet.total_ot_request_reject
                                )
                              }}
                              <div>{{ $t("dashboard.title.ot_tooltip3") }}</div>
                            </div>
                            <div v-else>
                              {{ $t("popup.overtime.label_popup_create") }}
                            </div>
                          </template>
                          <div
                            class="btn-fix__timeSheet"
                            @click="openOverTimeModal(timeSheet.work_date)"
                          >
                            <img
                              src="../../assets/icons/time-icon.svg"
                              alt=""
                            />
                            <div
                              v-if="
                                timeSheet.total_ot_request ||
                                timeSheet.total_ot_request_confirm ||
                                timeSheet.total_ot_request_reject
                              "
                              class="badge"
                              :class="
                                classRequestStatus(
                                  timeSheet.total_ot_request,
                                  timeSheet.total_ot_request_confirm,
                                  timeSheet.total_ot_request_reject
                                )
                              "
                            >
                              {{
                                timeSheet.total_ot_request ||
                                timeSheet.total_ot_request_confirm ||
                                timeSheet.total_ot_request_reject
                              }}
                            </div>
                          </div>
                        </a-tooltip>
                        <a-tooltip>
                          <template slot="title">
                            <div
                              v-if="
                                timeSheet.total_sabbatical_request ||
                                timeSheet.total_sabbatical_request_confirm ||
                                timeSheet.total_sabbatical_request_reject
                              "
                            >
                              {{
                                $t("dashboard.title.tooltip1") +
                                (timeSheet.total_sabbatical_request ||
                                  timeSheet.total_sabbatical_request_confirm ||
                                  timeSheet.total_sabbatical_request_reject) +
                                $t("dashboard.title.sabbatical_tooltip2") +
                                getTitleRequestStatus(
                                  timeSheet.total_sabbatical_request,
                                  timeSheet.total_sabbatical_request_confirm,
                                  timeSheet.total_sabbatical_request_reject
                                )
                              }}
                              <div>
                                {{ $t("dashboard.title.sabbatical_tooltip3") }}
                              </div>
                            </div>
                            <div v-else>
                              {{ $t("note.title.create_sabbatical") }}
                            </div>
                          </template>
                          <div
                            class="btn-fix__timeSheet"
                            @click="
                              openSabbaticalModal(
                                timeSheet.work_date,
                                timeSheet.day_off
                              )
                            "
                          >
                            <img
                              src="../../assets/icons/sabatical-icon.svg"
                              alt=""
                            />
                            <div
                              v-if="
                                timeSheet.total_sabbatical_request ||
                                timeSheet.total_sabbatical_request_confirm ||
                                timeSheet.total_sabbatical_request_reject
                              "
                              class="badge"
                              :class="
                                classRequestStatus(
                                  timeSheet.total_sabbatical_request,
                                  timeSheet.total_sabbatical_request_confirm,
                                  timeSheet.total_sabbatical_request_reject
                                )
                              "
                            >
                              {{
                                timeSheet.total_sabbatical_request ||
                                timeSheet.total_sabbatical_request_confirm ||
                                timeSheet.total_sabbatical_request_reject
                              }}
                            </div>
                          </div>
                        </a-tooltip>
                      </div>
                      <!-- </router-link> -->
                      <span v-else>-</span>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="13" class="text-center">
                      <span class="table-empty">{{
                        $t("table.label_data_not_found")
                      }}</span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </CCardBody>
      </CCard>
      <AddAdditionalTimesheetModal
        :visible="isOpenAddTimesheetByDate"
        :workDate="workDate"
        @cancel="closeAddTimesheetByDate"
        @ok="handleAddTimesheetByDate"
      />
      <CreateTimesheetModal
        @fetchData="fetchUserTimeSheetData"
        @fetchToTalDataDashBoard="fetchTimesheetTotalRequest"
        ref="createTimesheet"
      />
      <CreateOverTimeModal
        @fetchTotalRequest="fetchTotalRequest"
        ref="createOverTime"
      />
      <CreateSabbaticalRequestModal
        @fetchTotalRequest="fetchTotalRequest"
        ref="createSabbatical"
      />
      <CusModal
        @handleCancel="hidePopupIsNotAddTimeSheet"
        @handleOk="hidePopupIsNotAddTimeSheet"
        btnConfirm="OK"
        :showCancelBtn="false"
        :title="titleModalNotAddOrSubmitTimeSheet"
        :isShow="isShowModalIsNotAddTimeSheet"
      >
        <div class="modal-content">
          <div class="warning-title">
            <img src="/img/icons/warning-icon.svg" alt="" />
            {{ popUpNotAddTimeSheet }}
          </div>
        </div>
      </CusModal>
      <CusModal
        @handleCancel="hidePopupSubmit"
        @handleOk="hidePopupSubmit"
        btnConfirm="OK"
        :showCancelBtn="false"
        :title="titleModalSubmit"
        :isShow="isShowModalSubmit"
      >
        <div class="modal-content">
          <div class="warning-title">
            <img src="/img/icons/warning-icon.svg" alt="" />
            Bạn còn đơn chưa duyệt. Hãy kiểm tra lại!
          </div>
        </div>
      </CusModal>
      <CusModal
        @handleCancel="hidePopupAddTimeSheet"
        @handleOk="hidePopupAddTimeSheet"
        btnConfirm="OK"
        :showCancelBtn="false"
        :title="titleModalAddTimeSheet"
        :isShow="isShowModalAddTimeSheet"
      >
        <div class="modal-content">
          <div class="warning-title">
            <img src="/img/icons/warning-icon.svg" alt="" />
            Bạn còn đơn chưa duyệt. Hãy kiểm tra lại!
          </div>
        </div>
      </CusModal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import AddTimesheetModal from "./TimeSheetModal/AddTimesheetModal.vue";
import TimesheetSubmitModal from "./TimeSheetModal/TimesheetSubmitModal.vue";
import TimesheetSubmitConfimModal from "./TimeSheetModal/TimesheetSubmitConfimModal.vue";
import CreateTimesheetModal from "./TimeSheetModal/CreateTimesheetModal.vue";
import CreateOverTimeModal from "../OverTimeRequests/components/CreateOverTimeModal.vue";
import CreateSabbaticalRequestModal from "../SabbaticalLeaveRequest/modal/CreateSabbaticalRequestModal.vue";
import { formatNumber } from "@/utils/ui";
import AddAdditionalTimesheetModal from "../AdditionalTimesheet/Modals/AddAdditionalTimesheetModal.vue";
import CusModal from "@/components/commons/CusModal.vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

export default {
  name: "UserTimeSheet",
  metaInfo() {
    return {
      title: this.$t("page_title.page_timesheet_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    // TimeSheetStatical
    AddTimesheetModal,
    TimesheetSubmitModal,
    TimesheetSubmitConfimModal,
    CreateTimesheetModal,
    CreateOverTimeModal,
    AddAdditionalTimesheetModal,
    CreateSabbaticalRequestModal,
    CusModal,
  },
  data() {
    return {
      month: moment(),
      searchData: {
        month: null,
      },
      // isSubmited: false,
      timeRemain: null,
      isOpenAdd: false,
      isOpenSubmit: false,
      isOpenConfirm: false,
      isSubmitable: true,
      workDate: "",
      isOpenAddTimesheetByDate: false,
      isShowModalIsNotAddTimeSheet: false,
      isShowModalSubmit:false,
      isShowModalAddTimeSheet:false,
      isShowModalIsNotSubmitTimeSheet: false,
      titleModalNotAddOrSubmitTimeSheet: this.$t(
        "dashboard.button.add_timesheet"
      ),
      titleModalSubmit: "Xác nhận submit công ",
      titleModalAddTimeSheet: "Bổ sung công",
      popUpNotAddTimeSheet: "",
      timeSheetToday: {
        start_time_real: null,
        end_time_real: null,
      },
    };
  },
  async created() {
    if (this.sumittedInfomation?.submit_period?.submitable) {
      this.searchData.month = moment().subtract(1, "months").format("M/YYYY");
    } else {
      this.searchData.month = moment().format("M/YYYY");
    }
    await this.fetchAllData();
    await this.getTimeSheetToday();
    // await this.$root.$loading.finish();
  },
  computed: {
    ...mapGetters({
      timeSheets: "timeSheet/timeSheets",
      timeSheetTodayRes: "timeSheet/timeSheetToday",
      timesheetDashboard: "timeSheet/timesheetDashboard",
      timesheetTotalRequest: "timeSheet/timesheetTotalRequest",
      pagination: "timeSheet/pagination",
      listItemsPerPage: "commons/listItemsPerPage",
      sumittedInfomation: "commons/sumittedInfomation",
      account: "auth/account",
      dataCommons: "sabbatical-leave-request/dataCommons",
    }),
  },
  methods: {
    formatNumber,
    moment,
    sumWorkTime(work_time, ot_time,sabbatical_type, sabbatical_leave_minute, is_holiday = false) {
      const realWorkTime = moment(work_time, "HH:mm")
        // .subtract(moment.duration({ hours: 1, minutes: 30 }))
        .format("HH:mm");
      var workTime = moment.duration(realWorkTime);

      // subtract rounding error
      if(work_time == "08:01") {
        workTime = workTime.subtract(moment.duration({minutes: 1}))
      };
      if(work_time == "08:02") {
        workTime = workTime.subtract(moment.duration({minutes: 2}))
      };
      //sabbatical_leave_minute: 90
      // if(sabbatical_type == 4) {
      //   if(workTime.hours() < 8) {
      //     workTime = workTime.add(moment.duration({minutes: sabbatical_leave_minute}))
      //     var timeWorkingInDayDefaul = "08:00";
      //     timeWorkingInDayDefaul = moment(timeWorkingInDayDefaul, "HH:mm").format("HH:mm");
      //     const timeWorkingInDayDefaulDuration = moment.duration(timeWorkingInDayDefaul);
      //     if(workTime.hours() >= 8) {
      //       workTime = timeWorkingInDayDefaulDuration;
      //     }

      //   }
      // }
      const realOtTime = moment.duration(ot_time);
      var totalTime = workTime;
      if (!is_holiday) {
        totalTime = workTime.add(realOtTime);
      }
      let days =
        totalTime.days() ? `(${totalTime.days()}`+this.$t("day")+`)` : ``;
      let hours =
        totalTime.hours() < 10 ? `0${totalTime.hours()}` : totalTime.hours();
      let minutes =
        totalTime.minutes() < 10
          ? `0${totalTime.minutes()}`
          : totalTime.minutes();
      return `${days} ${hours}:${minutes}`;
    },
    checkPhysiologicalSabbaticalLeave(sabbatical_leave_type, sabbatical_leave_minute) {
      if(sabbatical_leave_type == 4) {
          var timeNull = "00:00";
          timeNull = moment(timeNull, "HH:mm").format("HH:mm");
          var timeNullDuration = moment.duration(timeNull);
          timeNullDuration = timeNullDuration.add(moment.duration({minutes: sabbatical_leave_minute}))

           let hours =
            timeNullDuration.hours() < 10 ? `0${timeNullDuration.hours()}` : timeNullDuration.hours();
          let minutes =
            timeNullDuration.minutes() < 10
              ? `0${timeNullDuration.minutes()}`
              : timeNullDuration.minutes();
          return `${hours}:${minutes}`;
      }
      return '-';
    },
    sumRealWorkTime(work_time, sabatical_time) {
      if (sabatical_time) {
        let workTimeHour = moment.duration(work_time).hours();
        let workTimeminute = moment.duration(work_time).minutes();
        let totalTimeminute =
          workTimeHour * 60 + workTimeminute - sabatical_time * 8 * 60;

        let realTimeHour = Math.floor(totalTimeminute / 60);
        if (realTimeHour < 10) realTimeHour = "0" + realTimeHour;
        let realTimeMinute = Math.round(totalTimeminute % 60);
        if (realTimeMinute < 10)
          realTimeMinute = "0" + Math.round(realTimeMinute);
        return `${realTimeHour}:${realTimeMinute}`;
      }

      return work_time
        ? moment(work_time, "HH:mm")
            // .subtract(moment.duration({ hours: 1, minutes: 30 }))
            .format("HH:mm")
        : "-";
    },
    disableMonth(current) {
      return (
        current &&
        (current > moment().endOf("day") ||
          current < moment("3/2018", "M/YYYY"))
      );
    },
    async fetchUserTimeSheetData() {
      await this.$store.dispatch("timeSheet/fetchUserTimeSheet", {
        month: this.searchData.month,
      });
      // this.searchData.paginate = this.pagination;
    },
    async fetchTimesheetDashboard() {
      await this.$store.dispatch("timeSheet/fetchTimesheetDashboard", {
        month: this.searchData.month,
      });
    },
    async fetchTimesheetTotalRequest() {
      await this.$store.dispatch("timeSheet/fetchTimesheetTotalRequest", {
        month: this.searchData.month,
      });
    },
    async fetchDataCommons() {
      await this.$store.dispatch("sabbatical-leave-request/getDataCommons");
    },
    getDataByMonth() {
      this.$root.$loading.start();
      Promise.all([
        this.fetchTimesheetDashboard(),
        this.fetchTimesheetTotalRequest(),
        this.fetchUserTimeSheetData(),
      ]).then(() => this.$root.$loading.finish());
    },
    fetchAllData() {
      this.$root.$loading.start();
      Promise.all([
        this.fetchTimesheetDashboard(),
        this.fetchTimesheetTotalRequest(),
        // this.getTimeSheetToday();
        this.$store.dispatch("auth/accountInfo"),
        this.fetchUserTimeSheetData(),
      ]).then(() => this.$root.$loading.finish());
    },
    fetchTotalRequest() {
      Promise.all([
        this.fetchTimesheetTotalRequest(),
        this.fetchUserTimeSheetData(),
      ]);
    },
    async search(month) {
      this.searchData.month = month;
      this.isSubmitable = false;
      try {
        await this.getDataByMonth();
        const currentMonth = moment().format("M/YYYY");
        const subMonth = moment().subtract(1, "months").format("M/YYYY");

        const isCurrentMonth = month === currentMonth;
        const isSubMonth = month === subMonth;
        if (isCurrentMonth) {
          this.isSubmitable = true;
        } else if (
          isSubMonth &&
          this.sumittedInfomation.submit_period.submitable
        ) {
          this.isSubmitable = true;
        } else {
          this.isSubmitable = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    classDayOff(data) {
      if (data === 1) {
        return "day-off";
      } else if (data === 2 || data === 3) {
        return "holiday-off";
      }
    },
    checkIsWeekend(day_of_week) {
      let isWeekend = false;
      if (day_of_week === "sunday" || day_of_week === "saturday") {
        isWeekend = true;
      }
      return isWeekend;
    },
    getTitleRequestStatus(pending, confirm, reject) {
      let result = "";
      if (pending) {
        result = this.$t("dashboard.title.tooltip_pending");
      } else if (confirm) {
        result = this.$t("dashboard.title.tooltip_aprove");
      } else if (reject) {
        result = this.$t("dashboard.title.tooltip_reject");
      }
      return result;
    },
    classRequestStatus(pending, confirm, reject) {
      let result = "";
      if (pending) {
        result = "tooltip--pending";
      } else if (confirm) {
        result = "tooltip--aprove";
      } else if (reject) {
        result = "tooltip--reject";
      }
      return result;
    },
    onclickOpenAddTimesheet() {
      if (!this.sumittedInfomation.submit_period.submitable || (moment().format('MM/YYYY') == moment(this.searchData.month, 'MM/YYYY').format('MM/YYYY'))) {
        this.titleModalNotAddOrSubmitTimeSheet = this.$t(
          "dashboard.button.add_timesheet"
        );
        this.popUpNotAddTimeSheet =
          this.$t("dashboard.title.is_not_add_timehseet_1") +
          this.sumittedInfomation.submit_period.submit_start +
          "-" +
          this.sumittedInfomation.submit_period.submit_end +
          ` tháng ${moment().add(1, 'months').format('MM/YYYY')}`;
        this.isShowModalIsNotAddTimeSheet = true;
      } else {
        const totalUnApproved = this.timesheetTotalRequest.totalOTRequestStatus[1] + this.timesheetTotalRequest.totalSabbaticalRequestStatus[1] + this.timesheetTotalRequest.totalTimesheetRequestStatus[1] + this.timesheetTotalRequest.totalRemoteRequestStatus[1];
        if (totalUnApproved > 0) {

          this.isShowModalAddTimeSheet = true;
        } else {
          this.isOpenAdd = true;
        }
      }
    },
    hidePopupIsNotAddTimeSheet() {
      this.isShowModalIsNotAddTimeSheet = false;
    },
    hidePopupSubmit() {
      this.isShowModalSubmit = false;
    },
    hidePopupAddTimeSheet() {
      this.isShowModalAddTimeSheet = false;
    },
    onClickOpenSubmit() {
      if (!this.sumittedInfomation.submit_period.submitable || (moment().format('MM/YYYY') == moment(this.searchData.month, 'MM/YYYY').format('MM/YYYY'))) {
        this.titleModalNotAddOrSubmitTimeSheet = this.$t(
          "dashboard.button.submit_timesheet"
        );
        this.popUpNotAddTimeSheet =
          this.$t("dashboard.title.is_not_submitable_1") +
          this.sumittedInfomation.submit_period.submit_start +
          "-" +
          this.sumittedInfomation.submit_period.submit_end +
          ` tháng ${moment().add(1, 'months').format('MM/YYYY')}`;
        this.isShowModalIsNotAddTimeSheet = true;
      } else {
        const totalUnApproved = this.timesheetTotalRequest.totalOTRequestStatus[1] + this.timesheetTotalRequest.totalSabbaticalRequestStatus[1] + this.timesheetTotalRequest.totalTimesheetRequestStatus[1] + this.timesheetTotalRequest.totalRemoteRequestStatus[1];
        if (totalUnApproved > 0) {
          this.isShowModalSubmit = true;
        } else {
          this.isOpenSubmit = true;
        }
      }
    },
    async submitable() {
      this.$root.$loading.start();
      try {
        await this.$store.dispatch("timeSheet/submitTimesheet", {
          month: this.searchData.month,
        });
        await this.fetchTimesheetDashboard();
        this.$root.$loading.finish();
        // this.isSubmited = true;
        this.isOpenConfirm = false;
        this.isOpenSubmit = false;
        this.$toast(
          this.$t("dashboard.modal.submit_timesheet_success"),
          this.$t("dashboard.modal.submit_timesheet"),
          2000,
          "b-toaster-top-center",
          "success"
        );
      } catch {
        this.$root.$loading.finish();
        this.$toast(
          this.$t("dashboard.modal.submit_timesheet_error"),
          this.$t("dashboard.modal.submit_timesheet"),
          2000,
          "b-toaster-top-center",
          "danger"
        );
      }
    },
    onClickUnsubmit() {
      this.isOpenConfirm = true;
    },
    closeUnsubmitModal() {
      this.isOpenConfirm = false;
    },
    async unsubmitable() {
      this.$root.$loading.start();
      try {
        await this.$store.dispatch("timeSheet/unsubmitTimesheet", {
          month: this.searchData.month,
        });
        await this.fetchTimesheetDashboard();
        this.$root.$loading.finish();
        this.isOpenConfirm = !this.isOpenConfirm;
        // this.isSubmited = false;
        this.$toast(
          this.$t("dashboard.modal.unsubmit_timesheet_success"),
          this.$t("dashboard.modal.unsubmit_timesheet"),
          2000,
          "b-toaster-top-center",
          "success"
        );
      } catch {
        this.$root.$loading.finish();
        this.$toast(
          this.$t("dashboard.modal.unsubmit_timesheet_error"),
          this.$t("dashboard.modal.unsubmit_timesheet"),
          2000,
          "b-toaster-top-center",
          "danger"
        );
      }
    },
    async handleAddTimesheet(compensationValue) {
      this.$root.$loading.start();
      try {
        await this.$store.dispatch("timeSheet/compensationTimesheet", {
          days_leave_used: compensationValue,
          month: this.searchData.month,
        });
        this.$root.$loading.finish();
        this.isOpenAdd = false;
        this.$toast(
          this.$t("dashboard.modal.add_timehseet_success"),
          this.$t("dashboard.modal.success"),
          2000,
          "b-toaster-top-center",
          "success"
        );
        await this.fetchAllData();
        await this.fetchDataCommons();
      } catch {
        this.$root.$loading.finish();
        this.$toast(
          this.$t("dashboard.modal.add_timehseet_error"),
          this.$t("dashboard.modal.error"),
          2000,
          "b-toaster-top-center",
          "error"
        );
      }
    },
    closeAddTimesheetModal() {
      this.isOpenAdd = false;
    },
    openAddTimesheetByDate(date) {
      this.workDate = date;
      this.isOpenAddTimesheetByDate = true;
    },
    handleAddTimesheetByDate() {
      this.isOpenAddTimesheetByDate = false;
      this.fetchUserTimeSheetData();
    },
    closeAddTimesheetByDate() {
      this.isOpenAddTimesheetByDate = false;
    },
    async getTimeSheetToday() {
      await this.$store.dispatch("timeSheet/fetchTimeSheetToday");
      if (this.timeSheetTodayRes.start_time_real !== undefined) {
        this.timeSheetToday = this.timeSheetTodayRes;
      }
    },
    async employeeCheckIn() {
      await Swal.fire({
        title: this.$t("popup.timesheet.label_checkin_title"),
        text: this.$t("popup.timesheet.label_checkin_text"),
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("popup.timesheet.label_confirm_button"),
        cancelButtonText: this.$t("popup.timesheet.label_cancel_button"),
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("timeSheet/checkIn")
            .then(() => {
              this.getTimeSheetToday();
              this.fetchUserTimeSheetData();
              Swal.fire(
                this.$t("popup.timesheet.label_checkin_success_title"),
                this.$t("popup.timesheet.label_checkin_success_text"),
                "success"
              );
            })
            .catch(() => {
              Swal.fire({
                icon: "error",
                text: this.$t("popup.timesheet.label_checkin_error_text"),
              });
            });
        }
      });
    },
    async employeeCheckOut() {
      Swal.fire({
        title: this.$t("popup.timesheet.label_checkout_title"),
        text: this.$t("popup.timesheet.label_checkout_text"),
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("popup.timesheet.label_confirm_button"),
        cancelButtonText: this.$t("popup.timesheet.label_cancel_button"),
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("timeSheet/checkOut")
            .then(() => {
              this.getTimeSheetToday();
              this.fetchUserTimeSheetData();
              Swal.fire(
                this.$t("popup.timesheet.label_checkout_success_title"),
                this.$t("popup.timesheet.label_checkout_success_text"),
                "success"
              );
            })
            .catch(() => {
              Swal.fire({
                icon: "error",
                text: this.$t("popup.timesheet.label_checkout_error_text"),
              });
            });
        }
      });
    },
    openOverTimeModal(date) {
      if (this.checkOTRequest(date)) {
        this.titleModalNotAddOrSubmitTimeSheet = this.$t(
          "popup.overtime.label_popup_create"
        );
        this.popUpNotAddTimeSheet = this.$t(
          "popup.overtime.label_popup_time_request_OT"
        );
        this.isShowModalIsNotAddTimeSheet = true;
      } else {
        this.$refs.createOverTime.showModal(date);
      }
    },
    openSabbaticalModal(date, dayoff) {
      if (this.checkSabbaticalRequest(dayoff)) {
        // this.$refs.createSabbatical.showModal(date);
        let routeData = this.$router.resolve({
          name: "Employee Sabbatical Leave Create",
          query: { date: date },
        });
        window.open(routeData.href, "_blank");
      } else {
        this.titleModalNotAddOrSubmitTimeSheet = this.$t("sabbatical.title");
        this.popUpNotAddTimeSheet = this.$t("dashboard.title.sabbatical_noti");
        this.isShowModalIsNotAddTimeSheet = true;
      }
    },
    checkOTRequest(date) {
      return moment(date, "DD/MM/YYYY").isBefore(moment().subtract(8, "days"));
    },
    checkSabbaticalRequest(dayoff) {
      return dayoff === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.time-sheet {
  margin-top: -20px;
  @media screen and (max-width: 740px) {
    margin-top: 12px;
  }
  .table-list {
    margin: 12px 0 0;
    .card-body {
      position: relative;
      padding: 19px 24px 30px;
      .card__header {
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // padding: 10px 0;

        .card-header__content {
          font-weight: 700;
          font-size: 18px;
          color: #3d4cdc;
        }
      }
    }

    .cl-pointer {
      cursor: pointer;
      .icon-sort {
        margin-left: 5px;
        .c-icon {
          width: 12px;
        }
        .sort-rotate {
          transform: rotate(180deg);
        }
      }
    }

    .work_date {
      text-align: center;
    }

    .employee__badge {
      background: #eff2f7;
      border-radius: 73px;
      padding: 4px 10px;
      font-weight: 700;

      .img__higher {
        filter: brightness(0) saturate(100%) invert(70%) sepia(52%)
          saturate(4593%) hue-rotate(347deg) brightness(101%) contrast(92%);
      }

      .span__higher {
        color: #f58722;
      }
      .span__lower {
        color: #0fa868;
      }
    }
    .day-off {
      background-color: #fff4e4;
    }
    .holiday-off {
      background-color: rgba(223, 49, 91, 0.1);
    }

    .employee__dayoff {
      color: #1190a6;
      font-weight: 700;
    }

    .employee__work {
      color: #0fa868;
      font-weight: 700;
    }

    .employee__holiday-off {
      color: #df315b;
      font-weight: 700;
    }

    .employee__leave {
      color: #f58722;
      font-weight: 700;
    }

    .employee__physiological {
      color: #000000;
      font-weight: 500;
    }

    .span__higher {
      color: #f58722;
      font-weight: 700;
    }
    .span__lower {
      color: #0fa868;
      font-weight: 700;
    }
    .action-btn-group {
      display: flex;
      gap: 5px;
      justify-content: center;

      .btn-fix__timeSheet {
        cursor: pointer;
        position: relative;
        width: 34px;
        height: 34px;
        background: #efefef;
        border: 1px solid #dcdcdc;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 16px;
          height: 16px;
        }
        .badge {
          position: absolute;
          border-radius: 50%;
          right: 0;
          top: -5px;
          // background: #f03d3e;
          color: #ffffff;
        }
        .tooltip--pending {
          background: #f58722;
        }
        .tooltip--aprove {
          background: #17a896;
        }
        .tooltip--reject {
          background: #f03d3e;
        }
      }
    }
  }
  .time-sheet-statical {
    position: relative;
    // margin: 15px;
    padding: 19px 24px 30px;
    background: #ffffff;
    border-radius: 0.25rem;
    font-weight: 400;
    font-size: 14px;
    .statical-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      .warning-time {
        color: #f58722;
      }
      .normal-time {
        color: #1190a6;
      }
      .submited-time {
        color: #0fa868;
      }
    }
    .statical-content {
      background: #ffffff;
      margin-bottom: 30px;

      .statical-item {
        padding: 15px 20px;
        background: #f8f8f8;
        min-width: 200px;
        width: 100%;
        // height: 100%;
        border-radius: 10px;
        border: 1px solid #e8e8e8;
        font-weight: 400;
        font-size: 14px;
        .item-header {
          padding-bottom: 15px;
          border-bottom: 1px solid #d3d3d3;
          font-weight: 500;
          font-size: 16px;
        }
        .item-footer {
          margin-top: 15px;
          font-weight: 700;
          .real-timesheet-list {
            display: flex;
            width: 100%;
            .real-timesheet-item {
              width: 20%;
              padding: 14px 5px;
              border-right: 1px solid #d3d3d3;
              text-align: center;
              &:last-child {
                border-right: none;
              }
            }
          }
          .list-item {
            display: flex;
            gap: 5px;
            margin-bottom: 10px;
            .item-label {
              min-width: 150px;
            }
          }
          .time-item {
            font-size: 28px;
            margin-bottom: 6px;
          }
          @media screen and (max-width: 767px) {
            .item-mobile {
              border-right: none;
            }
          }
        }
        .text_color--blue {
          color: #3488eb;
        }
        .text_color--red {
          color: #ff5253;
        }
        .text_color--green {
          color: #17a896;
        }
        .text_color--primary {
          color: #3d4cdc;
        }
        .text_color--grey {
          color: #978e8e;
        }
        .fs-70 {
          font-size: 70px;
          line-height: 70px;
        }
        .fs-28 {
          font-size: 28px;
        }
        .fw-700 {
          font-weight: 700;
        }
        .text_color--red {
          color: #ff5253;
        }
        .item-content {
          display: flex;
          justify-content: space-between;
          width: 100%;
          gap: 15px;
        }
      }
    }
    .statical-footer {
      background: #ffffff;
      display: flex;
      width: 100%;
      .footer-button {
        display: flex;
        margin: 0 auto;
        gap: 10px;
      }
    }
    .footer-btn {
      padding: 10px;
      border-radius: 10px;
      min-width: 200px;
      cursor: pointer;
      outline: none;
      border: none;
      img {
        margin-right: 5px;
      }
    }
    .submit-btn {
      background: #3d4cdc;
      color: #ffffff;
    }
    .compenstate-btn {
      background: #ffffff;
      color: #118fa6;
      border: 1px solid #118fa6;
    }
    .unsubmit-btn {
      background: #ff5253;
      color: #ffffff;
    }
    .btn-disabled {
      background: #e6e6e6;
      color: #9a9a9a;
    }
    .header-title {
      font-weight: 700 !important;
      font-size: 18px !important;
      color: #3d4cdc;
    }
    &.submit--success {
      background-color: #ebfff7;
      .statical-content {
        background-color: #ebfff7;

        .statical-item {
          border: 2px solid #0fa868;
        }
      }
      .statical-footer {
        background-color: #ebfff7;
      }
      .submited-disable {
        background: #e6e6e6;
        color: #9a9a9a;
      }
    }
    .submit-tick--success {
      position: absolute;
      z-index: 1;
      left: 50%;
      bottom: 50%;
      font-weight: 700;
      font-size: 150px;
      color: #0fa868;
      opacity: 0.1;
      transform: rotate(-30.65deg) translate(-50%, -50%);
      pointer-events: none;
    }
  }
  @media screen and (max-width: 740px) {
    .time-sheet__filter {
      margin: 0;
    }
  }
}
</style>

<style lang="scss">
.submit--success {
  .ant-calendar-picker-input {
    border: 2px solid #0fa868;
  }
}
.time-sheet-statical {
  .ant-calendar-picker-icon {
    width: 20px;
    height: 20px;
    margin-top: -9px;
  }
  .ant-calendar-picker-input {
    width: 212px;
    height: 40px;
    padding: 10px 14px;
    border-radius: 10px;
    color: #147ddf;
    font-weight: 700;
    font-size: 16px;
  }
}
</style>
<style lang="scss" scoped>
/deep/ .modal-content {
  border: none;
  text-align: center;
}
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #efefef;
  border-radius: 10px;
}
.table-content {
  min-width: 1130px;
  width: 100%;
  min-height: 170px;
  .table-header {
    tr {
      // border-top: 1px solid #fff;
      border-bottom: 1px solid #fff;
      th {
        padding: 15px 0px;
        min-width: 100px;
        background-color: #3488eb;
        border-right: 1px solid #fff;
        color: #fff;
        text-align: center;
      }
    }
  }
  .table-body {
    tr {
      td {
        padding: 15px 0px;
        border: 1px solid #efefef;
        text-align: -webkit-center;
      }
      td:first-child {
        border-left: none;
      }
      td:last-child {
        border-right: none;
      }
    }
    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
  .table-empty {
    position: absolute;
    left: 45%;
    bottom: 50px;
    opacity: 0.6;
  }
}
</style>
